//
//
//
//
//
//
//
//
//
//
//
//
//

import Item from "./Item.vue";

export default {
  props: ['filters', 'executeSearch', 'setFilterValue', 'filtergroup'],
  name: 'Group',
  data() {
    return {
      showingMore: false,
      showMoreText: "See More",
      showLessText: "See Less",
      filterShownCount:0,
      maxFiltersCount: 6
    }
  },
  components: {
    Item
  },
  computed: {
    displayName() {
      if (this.filtergroup?.name === 'Parts') {
        return 'Part Categories';
      }
      return this.filtergroup?.name || '';
    },
    childLookup() {
      const map = {};
      (this.filters || []).forEach(g => {
        if (g.hasParent) {
          map[g.id] = g;
        }
      });
      return map;
    },
    displayFilters() {
      // attach child filters to each top-level filter if a matching child group exists
      return (this.filtergroup.filters || []).map(f => {
        const childGroup = this.childLookup[f.id];
        if (childGroup && Array.isArray(childGroup.filters)) {
          return { ...f, filters: childGroup.filters };
        }
        return { ...f, filters: [] };
      });
    },
    availableFilters() {
      return this.filtersAvailable(this.displayFilters);
    },
    visibleFilters() {
      return this.availableFilters.slice(0, this.maxFiltersCount);
    },
    expandableFilters() {
      return this.availableFilters.slice(this.maxFiltersCount);
    },
    shouldShowMoreButton() {
      const totalFilters = this.displayFilters.filter(filter => {
        const hasChildren = !!(filter.filters && filter.filters.length);
        const isSelected = this.isFilterOrDescendantSelected(filter);
        const hasChildrenWithResults = hasChildren && this.hasDescendantWithCount(filter);
        return filter.count > 0 || isSelected || hasChildrenWithResults;
      }).length;
      return totalFilters > this.maxFiltersCount;
    }
  },
  methods: {
    filtersAvailable(filtersAvail){
      return filtersAvail.filter(
        (filter) => {
          const hasChildren = !!(filter.filters && filter.filters.length);
          // Show filter if it has count > 0, is selected (including nested filters), or has children with results
          const isSelected = this.isFilterOrDescendantSelected(filter);
          // Only show filters with children if at least one child has count > 0 or is selected
          const hasChildrenWithResults = hasChildren && this.hasDescendantWithCount(filter);
          return filter.count > 0 || isSelected || hasChildrenWithResults;
        }
      )
    },
    hasDescendantWithCount(filter) {
      if (!filter || !filter.filters || !filter.filters.length) {
        return false;
      }
      // Check if any child has count > 0 or is selected, or recursively check their children
      return filter.filters.some(child => 
        child.count > 0 || 
        child.selected || 
        this.hasDescendantWithCount(child)
      );
    },
    isFilterOrDescendantSelected(filter) {
      if (!filter) return false;
      if (filter.selected) return true;
      if (filter.filters && filter.filters.length) {
        return filter.filters.some(child => this.isFilterOrDescendantSelected(child));
      }
      return false;
    },
    showMoreFilters(event){
      this.showingMore = !this.showingMore;
    },
    slideEnter(element) {
      element.style.height = 'auto';
      const height = getComputedStyle(element).height;
      element.style.height = '0';
      element.style.opacity = '0';
      getComputedStyle(element).height;
      requestAnimationFrame(() => {
        element.style.height = height;
        element.style.opacity = '1';
      });
    },
    slideAfterEnter(element) {
      element.style.height = 'auto';
    },
    slideLeave(element) {
      const height = getComputedStyle(element).height;
      element.style.height = height;
      element.style.opacity = '1';
      getComputedStyle(element).height;
      requestAnimationFrame(() => {
        element.style.height = '0';
        element.style.opacity = '0';
      });
    }
  }
}
